import { Radio, Stack, Tooltip, Typography } from '@mui/material';
import colors from '/@/components/theme-provider/colors';
import settings from '/@/core/settings';

export type SelectionListActionItemProps = {
    leftItem?: React.ReactNode;
    title: string;
    subtitle?: string;
    rightItem?: 'radio' | 'checkbox';
    isSelected?: boolean;
    disabled?: boolean;
    disabledTooltip?: string;
    onClick?: (value: number) => void;
    firstAction?: string;
    firstActionIcon?: React.ReactNode;
    secondAction?: string;
    secondActionIcon?: React.ReactNode;
};

function SelectionListActionItem({
    title,
    subtitle,
    isSelected,
    disabled,
    disabledTooltip,
    onClick,
    firstAction,
    firstActionIcon,
    secondAction,
    secondActionIcon,
}: SelectionListActionItemProps) {
    return (
        <Tooltip title={disabled && disabledTooltip} arrow>
            <Stack
                direction='row'
                p={2}
                spacing={2}
                border={`1px solid ${isSelected ? colors.themes[settings.app.theme].mui.secondary.secondary : 'lightgray'}`}
                borderRadius='4px'
                alignItems='center'
                backgroundColor={
                    isSelected ? colors.themes[settings.app.theme].mui.primary.itemSelectedBackground : undefined
                }
                onClick={disabled ? undefined : onClick}
                sx={disabled ? {} : { cursor: 'pointer' }}
                justifyContent='space-between'
            >
                <Stack textAlign='left' width='100%' spacing={2}>
                    <Stack textAlign='left' width='100%'>
                        <Typography variant='subtitle1' color={disabled ? 'primary.mui.inactive' : 'primary'}>
                            {title}
                        </Typography>
                        <Typography variant='body2' color='primary.mui.inactive'>
                            {subtitle}
                        </Typography>
                    </Stack>
                    {firstAction ||
                        (secondAction && (
                            <Stack direction='row' textAlign='left' width='100%' spacing={2}>
                                <Stack direction='row' spacing={0.5} alignItems='center'>
                                    {firstActionIcon}
                                    <Typography
                                        variant='subtitle1'
                                        color='secondary'
                                        sx={{ textDecoration: 'underline' }}
                                    >
                                        {firstAction}
                                    </Typography>
                                </Stack>
                                <Stack direction='row' spacing={0.5} alignItems='center'>
                                    {secondActionIcon}
                                    <Typography
                                        variant='subtitle1'
                                        color='secondary'
                                        sx={{ textDecoration: 'underline' }}
                                    >
                                        {secondAction}
                                    </Typography>
                                </Stack>
                            </Stack>
                        ))}
                </Stack>
                <Radio checked={isSelected} color='secondary' disabled={disabled} size='large' />
            </Stack>
        </Tooltip>
    );
}

export default SelectionListActionItem;
